import { capitalize } from "@mui/material";
import { useEffect, useState } from "react";
import { SendPostRequest } from "../../http";
import { useSelector } from "react-redux";
import HeaderWrapper from "../Header/HeaderWrapper";
import FooterWrapper from "../Footer/FooterWrapper";
import { Link } from "react-router-dom";
import Spinner from "../Spinner";
import { formatDate } from "../../Helper/Helper";
import TextMainBannerWrapper from "../TextMainBanners/TextMainBannerWrapper";
import { Modal, Button } from "react-bootstrap";

function CareerInfoDuoBox() {
  const sitedata = useSelector((store) => store.global.loginData);
  const [careersData, setCareersData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);

  // Background images array
  const bgImages = [
    "/assets/images/mist/job-openings-1.webp",
    "/assets/images/mist/job-openings-2.webp",
    "/assets/images/mist/job-openings-3.webp",
    "/assets/images/mist/job-openings-4.webp",
    "/assets/images/mist/job-openings-5.webp",
    // "/assets/images/mist/job-openings-6.webp",
    // "/assets/images/mist/job-openings-7.webp",
  ];

  // Helper function: always return a random bg different from last
  const getRandomBg = (lastImage) => {
    let randomImage;
    do {
      randomImage = bgImages[Math.floor(Math.random() * bgImages.length)];
    } while (randomImage === lastImage);
    return randomImage;
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getCareerData();
  }, []);

  function isFutureDate(dateString) {
    const inputDate = new Date(dateString);
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    return inputDate > currentDate;
  }

  const getCareerData = async () => {
    const response = await SendPostRequest("careers/jobs");
    setCareersData(response?.data);
    setLoading(false);
  };

  const handleMoreDetails = (job) => {
    setSelectedJob(job);
    setShowModal(true);
  };

  return (
    <div className="page-wrapper-inner">
      <HeaderWrapper />
      <TextMainBannerWrapper Heading="Careers" Image="theme-2-banner-career.webp"/>

      <section id="career-section" className="career-section py-5">
        <div className="offset-md-2 col-md-8 ">
          <div className="title-wrap text-center ">
            <div className="section-title margin-bottom-80">
              <h2 className="section-title mb-0 text-uppercase">
                Available <span className="theme-color">Positions</span>
              </h2>
              <span className="section-border-bottom center"></span>
              {/* <p>
                Offer a wide range of services to help businesses establish.
              </p> */}
            </div>
          </div>
        </div>
        <div className="container">
          {loading ? (
            <div className="text-center">
              <Spinner />
            </div>
          ) : careersData?.jobs?.length > 0 ? (
            <div className="row">
              {(() => {
                let lastBg = null; // track last background
                return careersData.jobs.map((data, index) => {
                  const selectedBg = getRandomBg(lastBg);
                  lastBg = selectedBg; // update last bg for next loop

                  return (
                    <div className="col-lg-4 col-md-6 col-12 mb-4" key={index}>
                      <div className="feature-box-wrap f-box-style-6 relative" >
                        <div
                          className="feature-box-details d-flex flex-column"
                          style={{ minHeight: "510px" }}
                        >
                          <div className="feature-img">
                            <img
                              className="img-fluid"
                              src={selectedBg}
                              style={{ height: "auto" }}
                              alt="job bg"
                            />
                          </div>

                          <div className="feature-content mt-4 mb-0">
                            <div className="feature-title relative margin-bottom-5 ">
                              <div className="row">
                                <div className="col-8">
                                  <h5 className="mr-1">{data?.title}</h5>
                                </div>
                                <div
                                  className="col-4"
                                  style={{ display: "flex", justifyContent: "end" }}
                                >
                                  (<strong>{data?.job_type}</strong>)
                                </div>
                              </div>
                            </div>
                            <p className="mb-0 facilities-listing-1">
                              <strong>Experience: </strong>
                              {data?.experience}
                            </p>
                            <p className="mb-0 facilities-listing-1">
                              <strong>Deadline: </strong>
                              {formatDate(data?.dead_line)}
                            </p>
                          </div>

                          {/* Buttons wrapper - always at bottom */}
                          <div className="mt-auto d-flex justify-content-center gap-3 mt-0" style={{ padding: "5px 30px 15px 30px" }}>
                            {isFutureDate(data?.published_at) ? (
                              <div className="apply-btn career-apply-btn">
                                <Link className="btn btn-default" title="Apply Now">
                                  Coming Soon
                                </Link>
                              </div>
                            ) : (
                              <div className="apply-btn career-apply-btn">
                                <Link
                                  to={`/career/detail/${data?.uid}`}
                                  className="btn btn-default"
                                  title="Apply Now"
                                >
                                  Apply Now
                                </Link>
                              </div>
                            )}
                            <div className="apply-btn career-apply-btn">
                              <Button
                                variant="default"
                                className="btn btn-default"
                                onClick={() => handleMoreDetails(data)}
                              >
                                More Details
                              </Button>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  );
                });
              })()}
            </div>
          ) : (
            <div className="text-center">
              <p>No available positions at the moment. Please check back later.</p>
            </div>
          )}
        </div>
      </section>

      <FooterWrapper />

      {/* Job Details Modal */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className="career-job-modal-title">
            {selectedJob?.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="career-job-modal">
          {selectedJob && (
            <>
              {selectedJob?.content && (
                <div className="mb-2">
                  <label className="fw-bold">Job Description:</label>
                  <div dangerouslySetInnerHTML={{ __html: selectedJob?.content }} />
                </div>
              )}
              {selectedJob?.education && (
                <p><strong>Education:</strong> {selectedJob?.education}</p>
              )}
              {selectedJob?.experience && (
                <p><strong>Experience:</strong> {selectedJob?.experience}</p>
              )}
              {selectedJob?.languages && (
                <p><strong>Languages:</strong> {selectedJob?.languages}</p>
              )}
              {selectedJob?.segments && (
                <p><strong>Department:</strong> {selectedJob?.segments}</p>
              )}
              {selectedJob?.certifications && (
                <p><strong>Certifications:</strong> {selectedJob?.certifications}</p>
              )}
              {selectedJob?.dead_line && (
                <p><strong>Deadline:</strong> {formatDate(selectedJob?.dead_line)}</p>
              )}
              {selectedJob?.job_type && (
                <p><strong>Job Type:</strong> {selectedJob?.job_type}</p>
              )}
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          {/* <Button className="career-job-close-btn" onClick={() => setShowModal(false)}>
            Close
          </Button> */}
          <Button

            className="btn btn-default"
            onClick={() => setShowModal(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default CareerInfoDuoBox;
